export default function parseCookieTransfer<R>(
  transfer: (cookies: Record<string, string>) => R,
): R {
  const cookiesObj = document.cookie.split(';').reduce(
    (cookies, cookie) => {
      const [name, value] = cookie.trim().split('=');
      if (name && value) {
        cookies[name] = decodeURIComponent(value);
      }
      return cookies;
    },
    {} as Record<string, string>,
  );

  return transfer(cookiesObj);
}
